import React from "react";
import classnames from "classnames";
import { ReactComponent as SearchIcon } from "@ugg/shared/assets/svg/search-icon.svg";

interface ArenaSearchProps {
  className?: string;
  placeholder?: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

export function ArenaSearch(props: ArenaSearchProps) {
  const { className, placeholder, value, onChange } = props;

  return (
    <div
      className={classnames(
        "arena-search flex bg-purple-200 rounded-[3px] h-[36px] pl-[12px] pr-[6px] pt-[8px] pb-[8px] overflow-hidden focus-visible:outline-none",
        className,
      )}
    >
      <input
        className="flex-1 bg-inherit text-lavender-50 text-[14px] font-normal focus-visible:outline-none placeholder:text-lavender-50 overflow-hidden"
        type="text"
        placeholder={placeholder ?? ""}
        value={value}
        onChange={onChange}
      />
      <SearchIcon className="fill-lavender-200 ml-[11px] w-[24px]" />
    </div>
  );
}
